/**
 * Module definition houses stand-alone ui elements.
 *
 * @module stack.common.ui
 */
angular.module('stack.common.ui', [
  'stack.common.ui.application',
  'stack.common.ui.loader'
]);
